import styled from 'styled-components'

import { Button as GenericButton, TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  text-align: center;
`

export const MessageWrapper = styled.div`
  ${TypeStyle.css.headlineExtraSmall}
  color: ${o => o.theme.color.deprecated.obsidian};
  margin: 30px 0;

  ${fromMd} {
    margin: 48px 0 28px;
  }
`

export const Button = styled(GenericButton)`
  padding: 12px 32px;
`
